export const FORM_FIELD = {
  NAME: 'name',
  EMAIL: 'email',
  PASSWORD: 'password',
  PHONE: 'phone',
  COMPANY: 'company_name',
  COUNTRY: 'site_code',
  PHONE_CODE: 'phone_code',
  NEWSLETTER: 'newsletter_opt_in',
  ACCEPT: 'accept_terms',
} as const;

export type FieldNames = (typeof FORM_FIELD)[keyof typeof FORM_FIELD];

export type FormDataTuple = [FieldNames, string];
